import React, { useState, useEffect } from "react";
import axios from "axios";
import { getToken, getUser } from "../../../Utils/Common";
import { useNavigate } from "react-router-dom";

export default function TakePayment() {
  const token = getToken();
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(true);

  const createSubscriptionWithTrial = () => {
    setLoader(true);
    const user = getUser();
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}v1/user/create-subscription`,
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        price: "price_1KhY8bHuNOGPY9jaCIulrQ90",
      },
    })
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data);
          window.location.replace(response.data.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
          console.log(error.response);
        } else if (error.response.status === 401) {
          console.log(error.response);
        } else if (error.response.status === 422) {
          console.log(error.response.data.message);
          setMessage(error.response.data.message);
        } else {
        }
      })
      .then(() => {
        setLoader(false);
      });
  };

  return (
    <>
      <div
        className="d-flex flex-column flex-root"
        style={{ marginTop: "140px" }}
      >
        <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
          <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
            <div style={{ textAlign: "center" }}>
              <p style={{ color: "red", fontSize: "20px" }}>{message}</p>
            </div>
            <div className="w-lg-450px bg-body rounded border-black p-lg-5">
              <div className="col-12 text-center">
                <img src="/images/logo-short.png" style={{ width: "125px" }} />

                <p>
                  <strong>Premium Membership</strong>
                  <br />
                  Regular Price: $9.99/mo
                </p>
              </div>

              <div className="col-12">
                <strong>What do I get?</strong>
                <ul>
                  <li>
                    1 credit a month good for any title in our entire premium
                    selection, yours to keep
                  </li>
                  <li>No commitments. Cancel Anytime</li>
                  <li>A montly zoom meeting book club</li>
                </ul>
              </div>
            </div>
            <div className="mx-auto mt-3 mb-3">
              <button
                onClick={createSubscriptionWithTrial}
                className="btn btn-dark w-300px"
                type="button"
              >
                Start Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
